export const makeTransferList = ({ transfers, clubId }) => {
    const transfersResult = transfers.map( transfer => {
        const { amount, dateCreated, currency } = transfer;

        // Try to find corresponding admin/owner account
        //
        const direction = transfer.source._id === clubId ? 'sent' : 'claimedBack';
        const dealtAccount = transfer.source._id === clubId ? transfer.destination : transfer.source;

        // @TODO: Need to use the real applier data
        const applierAccount = transfer.source._id === clubId ? transfer.source : transfer.destination;

        return {
            amount,
            currency: 'chip',
            direction,
            date: dateCreated,
            applierName: applierAccount.nickname ? applierAccount.nickname : applierAccount.username,
            applierId: applierAccount._id,
            playerName: dealtAccount.nickname ? dealtAccount.nickname :  dealtAccount.username,
            playerId: transfer.source._id
        };
    });
    return transfersResult;
};

export const getProductType = (productsTypesList, productId) => {
    for(let productType in productsTypesList) {
        if(productsTypesList[productType].includes(productId)) {
            return productType;
        }
    }
}

export const makeGameTransferList = ( transfers ) => {
    const transferList  = transfers.map( transfer => {
        const { amount, dateCreated, productId, counterpartId, walletsAfter, type, details } = transfer;

        return {
            productId,
            amount, 
            currency: 'chip',
            date: dateCreated,
            gameId: counterpartId,
            balance: walletsAfter[0].balance,
            type: type,
            details
        }
    });
    return transferList;
}
